import Laridae from '../../../models/tools/laridae'

export function obtenerVersionLaridae () {
  return (dispatch) => {
    Laridae.getUltimaVersion()
      .then((data) => {
        dispatch({
          type: 'ULTIMA_VERSION',
          data: data
        })
      })
      .catch(error => {
        console.log(error)
      })
  }
}

export function setTitle (titulo) {
  console.log('dispatch...', actualizarTitulo(titulo))
  return (dispatch) => dispatch(actualizarTitulo(titulo))
}

export function actualizarTitulo (titulo) {
  return {
    type: 'SET_TITULO',
    titulo
  }
}

export function setShowFooter (show) {
  return (dispatch) => {
    dispatch({
      type: 'SET_SHOW_FOOTER',
      show
    })
  }
}

export function mapObjectsArrayToAllStringWithoutNulls (data) {
  return data ? data.map((d) =>
    Object.keys(d).reduce(
      (obj, key) => ({
        ...obj,
        [key]:
            d[key] === null || d[key] === undefined
              ? ''
              : `${d[key]}`.trim()
      }),
      {}
    )
  ) : data
};

export function zeroFill (number, width) {
  width -= number.toString().length
  if (width > 0) {
    return new Array(width + (/\./.test(number) ? 2 : 1)).join('0') + number
  }
  return number + '' // siempre devuelve tipo cadena
}
